module.exports = __webpack_public_path__ + "img/Identity-Pattern4.75cec600.svg";